
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";

import { PageSEO } from "@/components/PageSEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: Utente ha tentato di accedere a un percorso inesistente:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <PageSEO 
        title="Pagina Non Trovata - Gildy"
        description="La pagina che stai cercando non esiste o è stata spostata."
        canonicalPath="/404"
        noIndex={true}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id": "https://www.gildy.it/404#webpage",
          "name": "Pagina Non Trovata",
          "description": "La pagina che stai cercando non esiste o è stata spostata.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "@id": "https://www.gildy.it/404#breadcrumb",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.gildy.it"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Pagina Non Trovata"
              }
            ]
          }
        }}
      />
      
      {/* MainNav gestito globalmente da AppInner.tsx */}
      <main className="flex-1 container mx-auto py-20 px-4 md:px-6 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-6xl font-bold mb-4 metal-text">404</h1>
          <p className="text-xl text-muted-foreground mb-6">Oops! Pagina non trovata</p>
          <Link to="/" className="inline-flex metal-accent text-white px-4 py-2 rounded-md hover:opacity-90 transition-opacity">
            Torna alla Home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
